import './ClaimStatusText.scss';

const GenerateClaimStatus = ({ claim }) => {
    let txt = "תפסנו את המסמכים כמו כדור טניס";
    let icon = 1;
    let color = undefined;
    let colorText = "-on";
    let iconImg = undefined;

    console.log(claim.status);

    switch (claim.status * 1) {
        case -1:
            txt = "נותרו כמה שלבים לסיום ההגשה";
            icon = 1;
            color = "#FFCD0033";
            iconImg = "warn_yellow";
            break;
        case 0:
            icon = 1;
            break;
        case 1:
            icon = 1;
            txt = "חסרים לנו מסמכים כדי להתקדם";
            color = "#FE686933";
            iconImg = "warn_red";
            break;
        case 2:
        case 4:
        case 7:
        case 30:
        case 31:
        case 32:
            icon = 2;
            txt = "משחיזים ציפורניים ומתחילים לטפל";
            break;
        case 29:
        case 33:
        case 38:
            icon = 3;
            txt = "עוד נפנוף זנב ואנחנו שם";
            break;
        case 3:
        case 5:
        case 34:
        case 36:
        case 37:
        case 39:
            icon = 4;
            txt = "כבר ממש מריחים את הסוף";
            break;
        case 15:
            txt = "אושרה";
            icon = 4;
            color = "#7DCA78";
            colorText = "green";
            break;
        case 20:
            txt = "לא אושרה";
            icon = 4;
            color = "#AEAEAE";
            colorText = "gray";
            break;
        case 21:
            txt = "סגירה טכנית";
            icon = 4;
            color = "#AEAEAE";
            colorText = "gray";
            break;
    }

    return { txt, icon, color, colorText, iconImg };
}

const ClaimStatusLabel = ({ claim }) => {
    let status = GenerateClaimStatus({ claim });

    return (
        claim.status == 15 || claim.status == 20 || claim.status == 21 ?
            <div className={`claim-status-label`} style={{ backgroundColor: status.color }}><img src="/img/claim-icon-finished.svg" alt="" /><span>{status.txt}</span></div>
            :
            <div className={`claim-status-text`} style={{ backgroundColor: status.color, fontWeight: status.iconImg ? "bold" : undefined }}>{status.iconImg ? <img src={"/img/tracker/" + status.iconImg + ".svg"} alt="" /> : undefined}<span>{status.txt}</span></div>
    );
};

export { ClaimStatusLabel, GenerateClaimStatus };